import React from 'react';

function LifestyleStats({ count, onRefresh }) {
  return (
    <div className="card p-5">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-white">Collection overview</h2>
          <p className="text-xs text-gray-500 mt-0.5">Your exclusive lifestyle collection</p>
        </div>

        <div className="flex items-center gap-6">
          <div className="text-center">
            <div className="text-2xl font-bold text-white tabular-nums">{count}</div>
            <div className="text-xs text-gray-500">Total models</div>
          </div>
          <div className="hidden md:block w-px h-10 bg-line" />
          <div className="text-center hidden md:block">
            <div className="text-2xl font-bold text-emerald-400 tabular-nums">{count}</div>
            <div className="text-xs text-gray-500">Active</div>
          </div>
          <button type="button" onClick={onRefresh} className="btn-secondary !py-1.5 !px-3 ml-2">
            <svg className="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
}

export default LifestyleStats;
